import { createContext } from "react";

const APIData = createContext({})

export default APIData